import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { FilterState } from "@/components/AdvancedFilters";

interface ExploreActiveFiltersProps {
  advancedFilters: FilterState;
  setAdvancedFilters: (filters: FilterState) => void;
}

export function ExploreActiveFilters({
  advancedFilters,
  setAdvancedFilters,
}: ExploreActiveFiltersProps) {
  const hasActiveFilters = 
    advancedFilters.priceRange[0] > 0 || 
    advancedFilters.priceRange[1] < 50000 || 
    advancedFilters.technique !== "all" || 
    advancedFilters.color !== "all" ||
    advancedFilters.minWidth ||
    advancedFilters.maxWidth ||
    advancedFilters.minHeight ||
    advancedFilters.maxHeight;

  if (!hasActiveFilters) return null;

  const clearFilters = () => {
    setAdvancedFilters({
      priceRange: [0, 50000],
      technique: "all",
      color: "all"
    });
  };

  return (
    <div className="mb-4 flex flex-wrap gap-2">
      {(advancedFilters.priceRange[0] > 0 || advancedFilters.priceRange[1] < 50000) && (
        <Badge variant="secondary">
          Pris: {advancedFilters.priceRange[0].toLocaleString('sv-SE')} - {advancedFilters.priceRange[1].toLocaleString('sv-SE')} kr
        </Badge>
      )}
      {advancedFilters.technique !== "all" && (
        <Badge variant="secondary">
          Teknik: {advancedFilters.technique}
        </Badge>
      )}
      {advancedFilters.color !== "all" && (
        <Badge variant="secondary">
          Färg: {advancedFilters.color}
        </Badge>
      )}
      {(advancedFilters.minWidth || advancedFilters.maxWidth) && (
        <Badge variant="secondary">
          Bredd: {advancedFilters.minWidth || 0} - {advancedFilters.maxWidth || '∞'} cm
        </Badge>
      )}
      {(advancedFilters.minHeight || advancedFilters.maxHeight) && (
        <Badge variant="secondary">
          Höjd: {advancedFilters.minHeight || 0} - {advancedFilters.maxHeight || '∞'} cm
        </Badge>
      )}
      <Button variant="ghost" size="sm" onClick={clearFilters}>
        Rensa alla filter
      </Button>
    </div>
  );
}
